import { usePermission } from "../../hooks/tenant/usePermission";

const RoleGuard = ({ permission, children }) => {
  const { can } = usePermission();

  if (!can(permission)) return null;

  return children;
};

export default RoleGuard;
